import { Placement } from '@noths/polaris-client-ribbons-design-system';

import { usePageRichRelevanceData } from '../usePageRichRelevanceData';

export const HOMEPAGE_WITHOUT_PLACEMENT = 'home_page';

export interface UseHomepageRichRelevanceDataOptions {
  placementType: Placement | typeof HOMEPAGE_WITHOUT_PLACEMENT | null;
  sessionId?: string;
  hasDisabledCookies: boolean;
}

export const useHomepageRichRelevanceData = ({
  placementType,
  sessionId,
  hasDisabledCookies,
}: UseHomepageRichRelevanceDataOptions) =>
  usePageRichRelevanceData({
    sessionId,
    hasDisabledCookies,
    configurePlacement: () => {
      if (placementType) {
        window.R3_COMMON.addPlacementType(placementType);
        window.R3_HOME = new window.r3_home();

        if (placementType !== HOMEPAGE_WITHOUT_PLACEMENT) {
          return true;
        }
      }
      return false;
    },
  });
